export default __webpack_public_path__ + "static/devkit-c7c2dec2f3d6a5c6e26823ea28175762.svg";